import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup} from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { FinesService } from 'src/app/core/services/fines.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-fines-historical',
  templateUrl: './fines-historical.component.html',
  styleUrls: ['./fines-historical.component.css']
})
export class FinesHistoricalComponent implements OnInit {

  isArabic!: boolean;
    @Input() finesList: any;
    userData: any;
    form!: FormGroup;
    finesDetail: any[] = [];
    finesId?: string;  
  
     constructor( private router: Router,              
      private storageService: StorageService,
      private commonService: CommonService,
      private fb: FormBuilder,
      private finesService: FinesService
      ) { }
  
    ngOnInit(): void {
       this.isArabic = this.storageService.getSessionStorageData('isArabic');

       this.form = this.fb.group({
        fines: ['']
      });
       this.userData = this.storageService.getSessionStorageData('userDetails');
      const requestData = {
        assessmentUnitGuid: this.userData?.assessmentUnitValue,
      };
  
      this.finesService.fetchFinesHistory(requestData).subscribe(
        (res) => {
          if (res?.data) {
            const decryptedData = this.commonService.decryptUsingAES256(res?.data);
            const VOID_STATUS_CODE = 755020006;
            const PARTIALLY_PAID_STATUS_CODE = 755020005; 
            const PAID_STATUS_CODE = 755020004;
            const CLOSED_STATUS_CODE = 755020001; 
            const CANCELLED_STATUS_CODE = 755020002;

            // The array to filter the records you want to keep
            const filteredRecords = decryptedData.filter((item: any) => 
              item.mde_enforcementstatus === VOID_STATUS_CODE || 
              item.mde_enforcementstatus === PARTIALLY_PAID_STATUS_CODE || 
              item.mde_enforcementstatus === PAID_STATUS_CODE ||
              item.mde_enforcementstatus === CLOSED_STATUS_CODE ||
              item.mde_enforcementstatus === CANCELLED_STATUS_CODE
            );
            this.finesDetail = JSON.parse(JSON.stringify(filteredRecords));
          }
        },
        (error: any) => {
          console.error('Error fetching fines detail', error);
        }
      );
    
     
    }
  
      subscribeToEmitter(componentRef: any) {
        // if (!(componentRef instanceof  AssessmentSelectComponent)) {
        //   return;
        // }
        // const child: any = componentRef;
       
      
      }
   
     onListItemClick(selectedItemIdx: number) {
      this.finesList.forEach((v: any, i: any) => {
        if (i === selectedItemIdx) {
          v.isActive = true;
        } else {
          v.isActive = false;
        }
      });
       if (this.finesList[selectedItemIdx].link !== '') {
        let path = 'executor-dashboard/' + this.finesList[selectedItemIdx].link;
        this.router.navigate([path]);
      }
    }

    goToDetail(finesId: string) {
      if (finesId) {
        this.storageService.setSessionStorageData('finesId', finesId);
        this.storageService.setSessionStorageData('finesHistorical',true);
        this.router.navigate(
          ['/executor-dashboard/fines/detail'],
          { state: { finesId: finesId, finesHistorical: true} }
        );
      } else {
        alert(this.isArabic ? 'يرجى تحديد التقييم أولاً.' : 'Please select an assessment first.');
      }
    }
  
  }
